export default __webpack_public_path__ + "static/media/books-14.13b3c5ea.jpg";